<template>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" class="icon icon-tabler icon-tabler-camera-plus" viewBox="0 0 24 24">
        <path stroke="none" d="M0 0h24v24H0z"/>
        <circle cx="12" cy="13" r="3"/>
        <path d="M5 7h2a2 2 0 002-2 1 1 0 011-1h2m9 7v7a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2M15 6h6M18 3v6"/>
    </svg>
</template>